<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { nextStep } from "@/helpers/progress-helper.js";
import { onMounted } from "@vue/composition-api";

export default {
  setup(_, ctx) {
    onMounted(() => nextStep(ctx.root.$router));
    return {};
  },
};
</script>

<style lang="scss">
@import "styles/global-variables";
body {
  margin: 0;
  padding: 0;
}

*,
h1,
h2,
h3,
h4,
h5,
p {
  font-family: var(--font-regular);
}

a {
  color: var(--primary);
}

svg {
  max-height: unset;
}

input[type="text"],
input[type="tel"],
input[type="number"],
input[type="date"],
input[type="password"] {
  height: unset;
  font-size: 14px;
  line-height: 16px;
}

.app-container {
  background: rgba(114, 114, 114, 0.015);
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 1042px;
  min-height: 100vh;
  padding: {
    bottom: 24px;
    left: 16px;
    right: 16px;
  }

  &--with-progress {
    padding: 16px;

    @media screen and (min-width: $screen-medium) {
      align-items: stretch;
      display: flex;
      padding: {
        top: 32px;
        bottom: 32px;
      }

      > * {
        box-sizing: border-box;
        flex-grow: 0;
        flex-shrink: 0;
      }
    }

    .app-container-route {
      .membership-selected {
        align-items: center;
        color: var(--primary);
        display: flex;
        font-size: 10px;
        font-weight: 700;
        line-height: 28px;

        @media screen and (min-width: $screen-medium) {
          margin-bottom: 16px;
        }

        span {
          flex-grow: 1;
          margin-left: 8px;
          position: relative;

          &:after {
            content: "";
            background-color: rgba(114, 114, 114, 0.1);
            height: 1px;
            left: 0;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      @media screen and (min-width: $screen-medium) {
        border-right: 1px solid rgba(114, 114, 114, 0.1);
        padding: {
          left: 100px;
          right: 64px;
        }
        width: 70%;
      }
    }

    .app-container-progress {
      display: none;
      margin-top: 32px;
      padding-left: 64px;

      @media screen and (min-width: $screen-medium) {
        display: block;
        width: 30%;
      }
    }
  }
}

hr {
  border-color: rgba(114, 114, 114, 0.1);
  border-style: solid;
  margin: {
    top: 16px;
    bottom: 16px;
  }
}

.route-container {
  &--skinny {
    margin: 0 auto 24px;
    max-width: 586px;
  }

  &-inner {
    padding: 24px 0;
    border: {
      top: 1px solid rgba(114, 114, 114, 0.1);
      bottom: 1px solid rgba(114, 114, 114, 0.1);
    }
  }
}

.btn {
  border: 1px solid var(--primary);
  border-radius: 50px;
  box-sizing: border-box;
  display: inline-block;
  font-size: 14px;
  line-height: 20px;
  min-width: 130px;
  padding: 3px;
  text-align: center;
  text-decoration: none;
  transition: background-color 400ms ease-in-out, color 400ms ease-in-out,
    border-color 400ms ease-in-out;

  &--link {
    background: none;
    border: 0;
    color: var(--primary);
    min-width: unset;
    text-decoration: underline;

    &:hover {
      background: none;
      color: var(--dark-blue);
    }
  }

  &:not([disabled]) {
    cursor: pointer;
  }

  &--default {
    background: #ffffff;
    color: var(--primary);

    &:hover {
      background: var(--primary);
      border-color: var(--dark-blue);
      color: #ffffff;
    }
  }

  &--positive {
    background: var(--primary);
    color: #ffffff;

    &[disabled] {
      background: var(--mid-grey);
      border-color: var(--mid-grey);
      color: #ffffff;
    }

    &:not([disabled]):hover {
      background-color: var(--dark-blue);
      border-color: var(--dark-blue);
    }
  }
}

.form-controls {
  align-items: center;
  display: flex;
  justify-content: flex-end;

  .btn {
    margin-left: 16px;
  }
}

.notice {
  background: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  color: var(--body-light);
  margin-bottom: 16px;
  padding: 16px;

  &--success {
    background: rgba(135, 192, 92, 0.1);
    border-color: rgba(135, 192, 92, 0.1);
  }

  &--warn {
    background-color: rgba(255, 217, 71, 0.1);
    border-color: rgba(255, 217, 71, 0.1);
  }

  > p {
    font-size: 14px;
    line-height: 28px;
  }
}
</style>
